import { Types } from "./types";

const initialState = {
    dataMerchant: {
        rows: [],
        paging: {}
    },
    dataMerchantDetail: {},
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_MERCHANT:
            return {
                ...newState,
                dataMerchant: action.payload
            }
        case Types.SAVE_MERCHANT_DETAIL:
            return {
                ...newState,
                dataMerchantDetail: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
